<div class="overview-container">
  <!-- Title Section -->
  <div class="title-section">
    <h3 class="section-title">Overview</h3>
    <button class="edit-btn" (click)="onEditClick()">
      <span class="edit-text">Edit</span>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.99935 4.33321L11.666 6.99988M2.66602 13.3332H5.33268L12.3327 6.33321C12.5078 6.15811 12.6467 5.95024 12.7414 5.72147C12.8362 5.4927 12.885 5.2475 12.885 4.99988C12.885 4.75225 12.8362 4.50705 12.7414 4.27828C12.6467 4.04951 12.5078 3.84164 12.3327 3.66654C12.1576 3.49145 11.9497 3.35255 11.7209 3.25779C11.4922 3.16303 11.247 3.11426 10.9993 3.11426C10.7517 3.11426 10.5065 3.16303 10.2778 3.25779C10.049 3.35255 9.84111 3.49145 9.66602 3.66654L2.66602 10.6665V13.3332Z"
          stroke="#1B5BFF"
          stroke-width="1.25"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
  </div>

  <!-- Campaign Details Card -->
  <div class="campaign-details-card">
    <!-- Campaign Header -->
    <div class="campaign-header">
      <div class="campaign-title-section">
        <h4 class="campaign-title">{{ campaign.name }}</h4>
      </div>
      <p class="campaign-description">
        {{ campaign.description }}
      </p>
    </div>

    <!-- Divider -->
    <div class="divider"></div>

    <!-- Campaign Details Grid -->
    <div class="details-grid">
      <!-- Date of Incident -->
      <div class="detail-item">
        <div class="detail-label">CREATED ON</div>
        <div class="detail-value">{{ formatDate(campaign.schedule_start_date) }}</div>
      </div>

      <!-- Platform -->
      <div class="detail-item">
        <div class="detail-label">PLATFORM</div>
        <div class="detail-value">{{ getPlatformDisplay() }}</div>
      </div>

      <!-- User Segment -->
      <div class="detail-item">
        <div class="detail-label">USER SEGMENT</div>
        <div class="detail-value">
          <span *ngIf="campaign.segments && campaign.segments.length > 0">
            <span *ngFor="let segment of campaign.segments; let last = last; trackBy: trackByIndex">
              {{ segment.name }}<span *ngIf="!last">, </span>
            </span>
          </span>
          <span *ngIf="!campaign.segments || campaign.segments.length === 0">
            {{ campaign.user_segment || 'No segments' }}
          </span>
          <span class="user-count">(Total: {{ getUserCount() }} users)</span>
        </div>
      </div>

      <!-- Locations -->
      <div class="detail-item">
        <div class="detail-label">LOCATIONS</div>
        <div class="detail-value" [title]="getLocationTooltipText()">
          <span *ngFor="let location of campaign.locations; let last = last; trackBy: trackByIndex">
            {{ location.branch }}<span *ngIf="!last">, </span>
          </span>
        </div>
      </div>
    </div>

    <div class="divider" *ngIf="platformUrlRows.length || showLandingPagePendingHint"></div>

    <p class="platform-links-pending" *ngIf="showLandingPagePendingHint">
      {{ landingPagePendingHint }}
    </p>

    <div class="platform-links-section" *ngIf="platformUrlRows.length">
      <div
        class="platform-url-group"
        *ngFor="let row of platformUrlRows; trackBy: trackByPlatformId"
      >
        <div class="platform-link-row">
          <label class="platform-link-label" [attr.for]="'overview-campaign-url-' + row.id">
            Campaign URL ({{ row.platformName }})<span class="platform-required">*</span>
          </label>
          <div class="platform-link-input-wrap">
            <input
              [id]="'overview-campaign-url-' + row.id"
              class="platform-link-input platform-link-input--display"
              type="text"
              readonly
              [value]="row.campaignUrl"
              [title]="row.campaignUrl"
              tabindex="-1"
              [attr.aria-label]="'Campaign URL for ' + row.platformName"
            />
            <button
              type="button"
              class="platform-link-copy"
              (click)="copyPlatformUrl(row.campaignUrl)"
              [attr.aria-label]="'Copy campaign URL for ' + row.platformName"
            >
              Copy
            </button>
          </div>
        </div>

        <div class="platform-link-row">
          <label class="platform-link-label" [attr.for]="'overview-landing-page-url-' + row.id">
            Landing Page URL ({{ row.platformName }})
          </label>
          <div class="platform-link-input-wrap">
            <input
              [id]="'overview-landing-page-url-' + row.id"
              class="platform-link-input platform-link-input--display"
              type="text"
              readonly
              [value]="row.landingPageUrl"
              [title]="row.landingPageUrl"
              tabindex="-1"
              [attr.aria-label]="'Landing page URL for ' + row.platformName"
            />
            <button
              type="button"
              class="platform-link-copy"
              (click)="copyPlatformUrl(row.landingPageUrl, 'Landing page URL copied to clipboard.')"
              [attr.aria-label]="'Copy landing page URL for ' + row.platformName"
            >
              Copy
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="analytics-divider"></div>

    <!-- View Analytics Button -->
    <div class="analytics-button-container">
      <button class="analytics-btn" (click)="onViewAnalytics()">
        <svg
          width="17"
          height="12"
          viewBox="0 0 17 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.83333 6C6.83333 6.44203 7.00893 6.86595 7.32149 7.17851C7.63405 7.49107 8.05797 7.66667 8.5 7.66667C8.94203 7.66667 9.36595 7.49107 9.67851 7.17851C9.99107 6.86595 10.1667 6.44203 10.1667 6C10.1667 5.55797 9.99107 5.13405 9.67851 4.82149C9.36595 4.50893 8.94203 4.33333 8.5 4.33333C8.05797 4.33333 7.63405 4.50893 7.32149 4.82149C7.00893 5.13405 6.83333 5.55797 6.83333 6Z"
            stroke="#15172E"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M16 6C14 9.33333 11.5 11 8.5 11C5.5 11 3 9.33333 1 6C3 2.66667 5.5 1 8.5 1C11.5 1 14 2.66667 16 6Z"
            stroke="#15172E"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>

        <span class="analytics-text">View Analytics</span>
      </button>
    </div>
  </div>
</div>
